import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../hooks/authContext";
import { AppRoutes } from "../enums/Approutes";
import { MarkerProvider } from "../hooks/useMarker";
import Loader from "../assets/gifs/loader.gif";

const PrivateRoute = () => {
    const { isAuthenticated, isLoading } = useContext(AuthContext);

    if (isLoading || isAuthenticated === null) {
        return <div className='w-full h-auto flex items-center justify-center'>
            <img src={Loader} alt='Loading' style={{ width: '6rem', height: 'auto', objectFit: 'cover' }} />
        </div>
    }

    if (!isAuthenticated) {
        return <Navigate to={AppRoutes.LOGIN} replace />;
    }

    return (
        <MarkerProvider>
            <Outlet />
        </MarkerProvider>
    );
}

export default PrivateRoute;